(() => {
  if (window.__sgCommerceProductfinderExpansion) return;
  window.__sgCommerceProductfinderExpansion = true;

  const supported = new Set(['mus','maur','flue','skjeggkre','rotte','veps','veggedyr']);
  let rendering = false;

  function button(pest) {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'sg-ai-search__primary sg-commerce-expanded-assistant';
    b.dataset.sgStartAssistant = '';
    b.dataset.pest = pest;
    b.textContent = 'Start veiledning';
    return b;
  }

  function enhanceHome() {
    const C = window.SGCommerce;
    const root = C?.root?.();
    const home = root?.querySelector('[data-sg-search-home]');
    if (!home) return;

    const intro = home.querySelector('.sg-ai-search__intro');
    if (intro) {
      const strong = intro.querySelector('strong');
      const span = intro.querySelector('span');
      if (strong) strong.textContent = 'Beskriv problemet – vi hjelper deg fra bekjempelse til forebygging.';
      if (span) span.textContent = 'Du får produkter som finnes i butikken, en tydelig fremgangsmåte og guider som viser hvordan du gjør det.';
    }

    const chips = home.querySelector('.sg-ai-search__chips');
    if (chips) {
      [
        ['fluer på kjøkkenet','🪰 Fluer'],
        ['veps rundt terrassen','🐝 Veps'],
        ['mistanke om veggedyr','🛏️ Veggedyr'],
      ].forEach(([query,label]) => {
        if (chips.querySelector(`[data-sg-query="${query}"]`)) return;
        const b = document.createElement('button');
        b.type = 'button';
        b.dataset.sgQuery = query;
        b.textContent = label;
        chips.appendChild(b);
      });
    }
  }

  function enhanceResults() {
    const C = window.SGCommerce;
    const root = C?.root?.();
    const results = C?.results?.();
    const pest = C?.state?.pest;
    if (!C || !root || !results || !supported.has(pest) || root.classList.contains('is-assistant-mode')) return;
    if (rendering) return;
    rendering = true;

    const help = results.querySelector('.sg-commerce-help-card');
    if (help && !help.querySelector('[data-sg-start-assistant]')) {
      let kicker = help.querySelector('.sg-commerce-kicker');
      if (!kicker) {
        kicker = document.createElement('span');
        kicker.className = 'sg-commerce-kicker';
        help.prepend(kicker);
      }
      kicker.textContent = 'Personlig produktfinner';
      const h = help.querySelector('h3');
      const p = help.querySelector('p');
      if (h) h.textContent = 'Vil du at vi finner riktig løsning?';
      if (p) p.textContent = 'Svar på noen få spørsmål. Du får tiltak, produkter som finnes i butikken, forebygging og relevante guider.';
      const contact = help.querySelector('a.sg-ai-search__primary');
      if (contact) contact.className = 'sg-ai-search__secondary';
      help.insertBefore(button(pest), contact || null);
    }

    const actions = results.querySelector('.sg-commerce-empty-sales .sg-commerce-actions');
    if (actions && !actions.querySelector('[data-sg-start-assistant]')) actions.prepend(button(pest));
    requestAnimationFrame(() => { rendering = false; });
  }

  function enhanceAssistant() {
    const C = window.SGCommerce;
    const root = C?.root?.();
    const assistant = C?.assistant?.();
    if (!C || !root || !assistant || C.state.pest !== 'veggedyr' || !root.classList.contains('is-assistant-mode')) return;

    const intro = assistant.querySelector('.sg-commerce-assistant-head p');
    if (intro) intro.textContent = 'Først kartlegger du om det faktisk er veggedyr. Deretter velger du riktige tiltak og hindrer videre spredning.';

    const productSections = [...assistant.querySelectorAll('.sg-commerce-recommendation > section')]
      .filter((section) => section.querySelector('.sg-ai-search__products'));
    const firstHeading = productSections[0]?.querySelector('.sg-commerce-phase__head h3');
    const firstCopy = productSections[0]?.querySelector('.sg-commerce-phase__head p');
    if (firstHeading) firstHeading.textContent = 'Kartlegg og overvåk først';
    if (firstCopy) firstCopy.textContent = 'Produktene støtter inspeksjon, overvåking og en mer presis vurdering.';
  }

  function run() {
    enhanceHome();
    enhanceResults();
    enhanceAssistant();
  }

  document.addEventListener('sg:commerce:hybrid', () => {
    setTimeout(run, 40);
    setTimeout(run, 180);
  });
  document.addEventListener('sg:commerce:recommend', () => {
    setTimeout(run, 80);
    setTimeout(run, 220);
  });
  new MutationObserver(() => setTimeout(run, 20)).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['hidden'],
  });
  setTimeout(run, 100);
  setTimeout(run, 350);
})();
